import { Pipe, PipeTransform } from '@angular/core';
import { ChannelType } from '../models';

@Pipe({
  name: 'channelName',
  standalone: true,
})
export class ChannelNamePipe implements PipeTransform {
  transform(value: string): string {
    const defaultChannelNameMap: Record<ChannelType, string> = {
      facebook: 'Facebook',
      x: 'X (Twitter)',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      bluesky: 'Bluesky',
      threads: 'Threads',
      pinterest: 'Pinterest',
    };

    return defaultChannelNameMap[value as ChannelType] || value;
  }
}
